import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/webtrader/webtrader/message/fieldDefinition";
import { FormlyView } from "../FormlyView";

export class XEVPRMAck extends FormlyView
{

    constructor(
        form: FormGroup,
        fieldDefinition: FieldDefinition,
        model: {},
    ) {
        super(form, [...fieldDefinition.messageAckFields], model);
    }
    
}